<template>
  <GoogleMapLoader
    :mapConfig="mapConfig"
    apiKey="AIzaSyBtxRTQ3p12zJ9bB1_s9or7W0E3CES1wvU"
  >
    // insert your google maps api key to render styled map
    <template slot-scope="{ google, map }">
      <GoogleMapMarker
        v-for="marker in markers"
        :key="marker.id"
        :marker="marker"
        :google="google"
        :map="map"
        :infContent="marker.infContent"
        :icon="'https://firebasestorage.googleapis.com/v0/b/unimed-a36d6.appspot.com/o/guia-medico-maps-icon.png?alt=media&token=6e592b78-c6f9-4dc7-95b9-bf345972c631'"
      />
    </template>
  </GoogleMapLoader>
</template>

<script>
import GoogleMapLoader from '@/components/GoogleMaps/GoogleMapLoader.vue';
import GoogleMapMarker from '@/components/GoogleMaps/GoogleMapMarker.vue';

export default {
  components: {
    GoogleMapLoader,
    GoogleMapMarker,
  },

  data() {
    return {
      markers: [
        {
          id: 'a',
          position: { lat: -21.7666529, lng: -43.3494515 },
          infContent: `
          <div class="info_content">
            <h3 style="background-color: #00995d;color: white; padding: 5px; margin: 0px;">Espaço Viver Bem</h3>
            <p style=" color:#6c6c6c; margin: 0; line-height: 2"><strong>Av.Presidente Itamar Franco, 1.442 - Centro</strong></p>
            <p style="margin: 0">(32) 4009-5990 ou (32) 4009-5980</p>
            <small>Aberto de segunda a sexta-feira, das 7h às 20h</small>
          </div >`,
        },
        {
          id: 'b',
          position: { lat: -21.764393, lng: -43.348974 },
          infContent: `
          <div class="info_content">
            <h3 style="background-color: #00995d;color: white; padding: 5px; margin: 0px;">Operadora Unimed Juiz de Fora</h3>
            <p style=" color:#6c6c6c; margin: 0; line-height: 2"><strong>Av.Barão do Rio Branco, 2540 - Centro</strong></p>
            <p style="margin: 0">SAC 24h: 0800 030 11 66</p>
            <small>Aberto de segunda a sexta-feira, das 8h às 18h</small>
          </div >`,
        },
      ],
      lines: [
        {
          id: '1',
          path: [{ lat: 3, lng: 101 }, { lat: 5, lng: 99 }],
        },
        {
          id: '2',
          path: [{ lat: 5, lng: 99 }, { lat: 6, lng: 97 }],
        },
      ],
    };
  },

  computed: {
    mapConfig() {
      return {
        clickableIcons: false,
        streetViewControl: true,
        panControlOptions: false,
        gestureHandling: 'cooperative',
        mapTypeControl: false,
        zoomControlOptions: {
          style: 'SMALL',
        },
        zoom: 17,
        minZoom: 2,
        maxZoom: 30,
        center: this.mapCenter,
      };
    },

    mapCenter() {
      return this.markers[1].position;
    },
  },
};
</script>
